import { create, type AxiosInstance, type AxiosRequestConfig } from "axios";
import { createContext } from "react";
import Cookies from "js-cookie";

import { ensureApiPrefix } from "../../utils/ensureApiPrefix";
import { handleAuthenticationFailure } from "../../utils/handleAuthenticationFailure";
import { getPostHogHeaders } from "../../utils/posthog-headers";
import { getAppVersionHeaders } from "../../utils/app-version-headers";

export const AxiosContext = createContext<AxiosInstance>(undefined as any);

export interface AxiosProviderConfig {
  axiosConfig?: AxiosRequestConfig;
}

const instance = create({
  headers: {
    "Content-Type": "application/json",
  },
});

// Request interceptor to ensure all API calls have /api prefix and set CSRF token
instance.interceptors.request.use((config) => {
  config.url = ensureApiPrefix(config.url);

  const csrfToken = Cookies.get("csrftoken");
  if (csrfToken) {
    config.headers["X-CSRFToken"] = csrfToken;
  }

  return config;
});

// Request interceptor to inject PostHog session and user context headers
instance.interceptors.request.use((config) => {
  const posthogHeaders = getPostHogHeaders();
  Object.assign(config.headers, posthogHeaders);
  return config;
});

// Request interceptor to inject app version and name headers
instance.interceptors.request.use((config) => {
  const versionHeaders = getAppVersionHeaders();
  Object.assign(config.headers, versionHeaders);
  return config;
});

instance.interceptors.response.use((response) => {
  handleAuthenticationFailure(response);
  return response;
});

export const axiosClient = instance;
